import {FC} from 'react';
import {Box} from '@mui/material';
import {ContractSummary} from '../../modules/contracts';

const ContractPage: FC = () => {
  return (
    <Box>
      <ContractSummary />
    </Box>
  );
};

export default ContractPage;
